// Cart Upsell — Mercier
const UPSELL_CONTAINER_ID = 'mercier-upsell';
let upsellProducts = [];
let isInjecting = false;

async function fetchUpsellProducts() {
  const res = await fetch('/collections/upsell-accessoires/products.json?limit=8');
  const data = await res.json();
  return data.products?.map(p => ({
    title: p.title,
    handle: p.handle,
    image: p.images[0]?.src || '',
    price: p.variants[0]?.price * 100,
    variants: p.variants
  })) || [];
}

function formatMoney(cents) {
  return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
}

function renderUpsell(products, container) {
  if (!products.length) return;
  container.innerHTML = `
    <div style="padding: 1rem 0 0.5rem; border-top: 1px solid rgba(0,0,0,0.1); margin-top: 0.5rem;">
      <p style="font-size: 0.75rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.08em; margin-bottom: 0.75rem; color: inherit;">Complétez votre équipement</p>
      <div id="upsell-carousel" style="display: flex; gap: 0.75rem; overflow-x: auto; scroll-snap-type: x mandatory; -webkit-overflow-scrolling: touch; padding-bottom: 0.5rem; scrollbar-width: none;">
        ${products.map(p => `
          <div style="flex: 0 0 130px; scroll-snap-align: start; padding: 0.6rem; text-align: center; background: transparent; display: flex; flex-direction: column;">
            <a href="/products/${p.handle}" style="text-decoration: none; color: inherit; flex: 1; display: flex; flex-direction: column;">
              <img src="${p.image}" alt="${p.title}" style="width:100%; aspect-ratio:1; object-fit:cover; border-radius:2px; margin-bottom:0.4rem;" loading="lazy">
              <p style="font-size: 0.72rem; margin-bottom: 0.2rem; line-height: 1.3; color: inherit; flex: 1;">${p.title}</p>
              <p style="font-size: 0.78rem; font-weight: 600; margin-bottom: 0.5rem; color: inherit;">${formatMoney(p.price)}</p>
            </a>
            <button onclick="upsellAddToCart('${p.variants[0]?.id}', this)"
              style="width:100%; padding: 0.35rem 0; font-size: 0.72rem; cursor:pointer; border: 1px solid #111; background:#111; color:#fff; border-radius:2px; letter-spacing:0.03em; margin-top: auto;">
              Ajouter
            </button>
          </div>
        `).join('')}
      </div>
    </div>
  `;
  if (!document.getElementById('upsell-style')) {
    const style = document.createElement('style');
    style.id = 'upsell-style';
    style.textContent = `
      #upsell-carousel::-webkit-scrollbar { display: none; }
      @media (max-width: 749px) {
        #mercier-upsell div[style*="padding: 1rem"] > p {
          font-size: 0.65rem;
        }
        #upsell-carousel > div {
          flex: 0 0 80px !important;
          padding: 0.3rem !important;
        }
        #upsell-carousel img {
          margin-bottom: 0.2rem !important;
        }
        #upsell-carousel p {
          font-size: 0.6rem !important;
          margin-bottom: 0.1rem !important;
        }
        #upsell-carousel button {
          font-size: 0.6rem !important;
          padding: 0.2rem 0 !important;
        }
      }
    `;
    document.head.appendChild(style);
  }
}

window.upsellAddToCart = async function(variantId, btn) {
  btn.disabled = true;
  btn.textContent = '...';

  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      sections: 'cart-drawer',
      sections_url: window.location.pathname
    })
  });

  const data = await res.json();

  if (data.sections?.['cart-drawer']) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(data.sections['cart-drawer'], 'text/html');
    const newDrawerContent = doc.querySelector('#cart-drawer');
    const currentDrawer = document.querySelector('#cart-drawer');
    if (newDrawerContent && currentDrawer) {
      currentDrawer.innerHTML = newDrawerContent.innerHTML;
    }
  }

  setTimeout(async () => {
    isInjecting = false;
    await injectUpsell();
  }, 100);
};

async function injectUpsell() {
  if (isInjecting) return;
  isInjecting = true;

  const drawer = document.querySelector('#cart-drawer');
  if (!drawer) { isInjecting = false; return; }
  if (drawer.querySelector(`#${UPSELL_CONTAINER_ID}`)) { isInjecting = false; return; }

  const upsellDiv = document.createElement('div');
  upsellDiv.id = UPSELL_CONTAINER_ID;

  const checkout = drawer.querySelector('[name="checkout"], .cart__checkout, a[href="/checkout"]');
  if (checkout) {
    const checkoutParent = checkout.closest('div, form, p') || checkout.parentNode;
    checkoutParent.insertAdjacentElement('afterend', upsellDiv);
  } else {
    drawer.appendChild(upsellDiv);
  }

  if (!upsellProducts.length) {
    upsellProducts = await fetchUpsellProducts();
  }
  renderUpsell(upsellProducts, upsellDiv);
  isInjecting = false;
}

// Observer
const drawer = document.querySelector('#cart-drawer');
if (drawer) {
  const drawerObserver = new MutationObserver(async () => {
    if (drawer.hasAttribute('open') && !drawer.querySelector(`#${UPSELL_CONTAINER_ID}`) && !isInjecting) {
      await injectUpsell();
    }
  });
  drawerObserver.observe(drawer, {
    attributes: true,
    attributeFilter: ['open'],
    childList: true,
    subtree: true
  });
}
